import React from 'react';
import {useForm} from "react-hook-form";
import {Link, NavLink} from 'react-router-dom'

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
// import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';

import * as Security from '../../../utils/auth/Security';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as DataPattern from '../../constants/DataPattern';
import * as CustomStyles from '../../styles/CustomStyles';
import { RoleClient } from "../../constants/Consts";
import * as Formatter from '../../util/Formatter';


// function WorksiteDialog(props) {
//     const { register, handleSubmit, reset, formState: { errors, defaultValues } } = useForm({
//         defaultValues: {
//             lWorksite: props.worksite,
//         } 
//     });

//     const [open, setOpen] = React.useState(false);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     const handleSubmitWLData = (data, event) => {
//         event.preventDefault();
//         const worksite = data.lWorksite;

//         props.saveWorksite(worksite);
//         handleClose();
//         reset();
//     }

//     return(
//         <React.Fragment>
//             { props.buttonType === 'Button' ?
//                 <Button variant="outlined" sx={{ marginRight: 2 }}  onClick={handleClickOpen}>
//                     {props.buttonName}
//                 </Button>
//                 :
//                 <Link
//                     component="button"
//                     variant="body2"
//                     onClick={handleClickOpen}
//                 >
//                     {props.buttonName}
//                 </Link>
//             }


//             <Dialog open={open} onClose={handleClose} maxWidth='md'>
//                 <DialogTitle>
//                     Punct de lucru
//                     <IconButton
//                         aria-label="close"
//                         onClick={handleClose}
//                         sx={{
//                             position: 'absolute',
//                             right: 8,
//                             top: 8,
//                             color: (theme) => theme.palette.grey[500],
//                         }}
//                         >
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <form id='wlForm' onSubmit={handleSubmit(handleSubmitWLData)}>
//                 <DialogContent dividers>
//                     <Grid container spacing={2} sx={CustomStyles.gridStyles}>
//                         {/*row*/}
//                         <Grid item xs={12}>
//                             <TextField variant="standard" size="small" label="Nume" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.name", {required: ValidationMessages.REQUITED_MESSAGE})} 
//                                 error={!!errors?.lWorksite?.generalSection?.name}
//                                 helperText={errors?.lWorksite?.generalSection?.name ? errors.lWorksite.generalSection.name.message : null}
//                             />
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={4}>
//                             <CustomSelect 
//                                 selectId={'wlJudet'} 
//                                 selectType={SelectTypes.JUDETE} 
//                                 value={defaultValues.lWorksite.generalSection.judet} 
//                                 register={{...register('lWorksite.generalSection.judet', {required: ValidationMessages.REQUITED_MESSAGE})}}
//                                 error={!!errors?.lWorksite?.generalSection?.judet}
//                                 helperText={errors?.lWorksite?.generalSection?.judet ? errors.lWorksite.generalSection.judet.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={6}>
//                             <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.localitate", {required: ValidationMessages.REQUITED_MESSAGE})} 
//                                 error={!!errors?.lWorksite?.generalSection?.localitate}
//                                 helperText={errors?.lWorksite?.generalSection?.localitate ? errors.lWorksite.generalSection.localitate.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.sector")} 
//                                 error={!!errors?.lWorksite?.generalSection?.sector}
//                                 helperText={errors?.lWorksite?.generalSection?.sector ? errors.lWorksite.generalSection.sector.message : null}
//                             />
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.postalCode", {required: ValidationMessages.REQUITED_MESSAGE})} 
//                                 error={!!errors?.lWorksite?.generalSection?.postalCode}
//                                 helperText={errors?.lWorksite?.generalSection?.postalCode ? errors.lWorksite.generalSection.postalCode.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={6}>
//                             <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.street", {required: ValidationMessages.REQUITED_MESSAGE})} 
//                                 error={!!errors?.lWorksite?.generalSection?.street}
//                                 helperText={errors?.lWorksite?.generalSection?.street ? errors.lWorksite.generalSection.street.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.no")} 
//                                 error={!!errors?.lWorksite?.generalSection?.no}
//                                 helperText={errors?.lWorksite?.generalSection?.no ? errors.lWorksite.generalSection.no.message : null}
//                             />
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.bloc")} 
//                                 error={!!errors?.lWorksite?.generalSection?.bloc}
//                                 helperText={errors?.lWorksite?.generalSection?.bloc ? errors.lWorksite.generalSection.bloc.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.scara")} 
//                                 error={!!errors?.lWorksite?.generalSection?.scara}
//                                 helperText={errors?.lWorksite?.generalSection?.scara ? errors.lWorksite.generalSection.scara.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.etaj")} 
//                                 error={!!errors?.lWorksite?.generalSection?.etaj}
//                                 helperText={errors?.lWorksite?.generalSection?.etaj ? errors.lWorksite.generalSection.etaj.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.apartment")} 
//                                 error={!!errors?.lWorksite?.generalSection?.apartment}
//                                 helperText={errors?.lWorksite?.generalSection?.apartment ? errors.lWorksite.generalSection.apartment.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                             <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.buzzer")} 
//                                 error={!!errors?.lWorksite?.generalSection?.buzzer}
//                                 helperText={errors?.lWorksite?.generalSection?.buzzer ? errors.lWorksite.generalSection.buzzer.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={2}>
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Nume Reprezentant Legal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.legalRepresentativeName")} 
//                                 error={!!errors?.lWorksite?.generalSection?.legalRepresentativeName}
//                                 helperText={errors?.lWorksite?.generalSection?.legalRepresentativeName ? errors.lWorksite.generalSection.legalRepresentativeName.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Telefon Reprezentant Legal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.legalRepresentativePhone",
//                                     {pattern: {
//                                         value: DataPattern.PATTERN_PHONE_NUMBER,
//                                         message: ValidationMessages.INVALID_PHONE_NUMBER,
//                                     }}
//                                 )} 
//                                 error={!!errors?.lWorksite?.generalSection?.legalRepresentativePhone}
//                                 helperText={errors?.lWorksite?.generalSection?.legalRepresentativePhone ? errors.lWorksite.generalSection.legalRepresentativePhone.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Email Reprezentant Legal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.legalRepresentativeEmail",
//                                     {pattern: {
//                                         value: DataPattern.PATTERN_EMAIL_ADDRESS,
//                                         message: ValidationMessages.INVALID_EMAIL_ADDRESS,
//                                     }}
//                                 )} 
//                                 error={!!errors?.lWorksite?.generalSection?.legalRepresentativeEmail}
//                                 helperText={errors?.lWorksite?.generalSection?.legalRepresentativeEmail ? errors.lWorksite.generalSection.legalRepresentativeEmail.message : null}
//                             />
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Nume Reprezentant Legal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.lucratorDesemnatName")} 
//                                 error={!!errors?.lWorksite?.generalSection?.lucratorDesemnatName}
//                                 helperText={errors?.lWorksite?.generalSection?.lucratorDesemnatName ? errors.lWorksite.generalSection.lucratorDesemnatName.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Telefon Reprezentant Legal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.lucratorDesemnatPhone",
//                                     {pattern: {
//                                         value: DataPattern.PATTERN_PHONE_NUMBER,
//                                         message: ValidationMessages.INVALID_PHONE_NUMBER,
//                                     }}
//                                 )} 
//                                 error={!!errors?.lWorksite?.generalSection?.lucratorDesemnatPhone}
//                                 helperText={errors?.lWorksite?.generalSection?.lucratorDesemnatPhone ? errors.lWorksite.generalSection.lucratorDesemnatPhone.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={4}>
//                             <TextField variant="standard" size="small" label="Email Reprezentant Legal" fullWidth margin="dense" 
//                                 {...register("lWorksite.generalSection.lucratorDesemnatEmail",
//                                     {pattern: {
//                                         value: DataPattern.PATTERN_EMAIL_ADDRESS,
//                                         message: ValidationMessages.INVALID_EMAIL_ADDRESS,
//                                     }}
//                                 )} 
//                                 error={!!errors?.lWorksite?.generalSection?.lucratorDesemnatEmail}
//                                 helperText={errors?.lWorksite?.generalSection?.lucratorDesemnatEmail ? errors.lWorksite.generalSection.lucratorDesemnatEmail.message : null}
//                             />
//                         </Grid>

//                     </Grid>
//                 </DialogContent>

//                 <DialogActions>
//                     <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
//                         <Button onClick={handleClose}>Inchide</Button>
//                         {/* {Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) ? */}
//                         { ( Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) || 
//                             (Security.getAuthorizedClient() && Security.getAuthorizedClient() != props.worksite.generalSection.rsvtiMBClientId) ) ?
//                             <React.Fragment></React.Fragment>
//                                 :
//                             <Button type='submit'>Salveaza</Button>
//                         }
//                     </Box>
//                 </DialogActions>

//                 </form>
//             </Dialog>
//         </React.Fragment>
//     );
// }


function EmployerWorksites(props) {
    console.log('Employer Worksites Section');

    const columns = [
        {
            field: 'worksiteName',
            headerName: 'Punct de lucru',
            width: 325,
            valueGetter: (params) => params.row.generalSection.name,
            renderCell: (params) => {
                return (
                    // <WorksiteDialog
                    //     buttonType={'Link'}
                    //     buttonName={params.row.generalSection.name}
                    //     worksite={params.row}
                    //     saveWorksite={props.patchWorksite}
                    //     employerRsvtiMB={props.employer.generalSection.rsvtiMBClientId}
                    // />
                    <Link to={`/employers/worksites/${params.row.id}`}>
                        {params.row.generalSection.name}
                    </Link>
                );
            }
        },
        {
            field: 'judet',
            headerName: 'Judet',
            width: 175,
            valueGetter: (params) => params.row.generalSection.judet
        },
        {
            field: 'localitate',
            headerName: 'Oras',
            width: 175,
            valueGetter: (params) => params.row.generalSection.localitate
        },
        {
            field: 'updateDate',
            headerName: 'Data Modificare',
            width: 115,
            valueGetter: (params) => params.row.updateDate,
            renderCell: (params) => {
                return(Formatter.formatDatetoRO(params.row.updateDate));
            }            
        },
    ]

    return (
        <Stack spacing={1} sx={{marginBottom: 2}}>
            <div style={{ display: "flex" }}>

                {/* {Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) ? */}
                { ( Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) || 
                    (Security.getAuthorizedClient() && Security.getAuthorizedClient() != props.employer.generalSection.rsvtiMBClientId) ) ?
                    <React.Fragment></React.Fragment>
                        :
                    <Box sx={{ width: '100%', marginTop: 2 }} display="flex" justifyContent="flex-end" alignItems="flex-end">
                        <Link to={`/employers/new-worksite?employerId=${props.employer.id}`}>
                            <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Punct De Lucru</Button>
                        </Link>
                        {/* <WorksiteDialog
                            buttonType={'Button'}
                            buttonName={'Adauga Punct De Lucru'}
                            worksite={{ generalSection: {employerId: props.employer.id, rsvtiMBClientId: props.employer.generalSection.rsvtiMBClientId} }}
                            saveWorksite={props.postWorksite}
                        /> */}
                    </Box>
                }
            </div>

            <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                <DataGrid
                    rows={props.worksites}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                />
            </Box>

        </Stack>
    );
}


export default EmployerWorksites;